<template>
  <slot v-if="status === 'pending'" name="loading" />
  <slot v-else />
</template>

<script setup lang="ts">
import { watchEffect } from 'vue'

import { useBouyguesPhonelineSetup } from '@backmarket/nuxt-layer-checkout/composables/useBouyguesPhonelineSetup'

const emit = defineEmits<{
  (e: 'empty-response'): void
}>()

const { isEmpty, status } = useBouyguesPhonelineSetup()

watchEffect(() => {
  if (status.value === 'success' && isEmpty.value) {
    emit('empty-response')
  }
})
</script>
